// src/components/UserRemoveMultipleAccess.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import ModalVw, { ModalBody, ModalContent, ModalHeader } from "./common/ModalVw";
import SearchUser from "./SearchUser";
import DataTable from "./provider/datatable/Datatable";
import SearchIcon from "../images/search.svg";
import axios from "axios";
import { urlValue, useTranslate, openAlert, loadingContext } from "../lib";
import '../styles/user_remove_project_access.css'

const UserRemoveMultipleAccess = ({
    isOpen,
    onClose,
    usersToRemoveAccess,
    setUsersToRemoveAccess,
    projectsToRemoveAccess,
    setProjectsToRemoveAccess,
    selectedRadio,
    setSelectedRadio,
    onConfirmRemoveAccess,
    checkLocalStorage,
    userProjects,
    setUserProjects,
}) => {
    const { t } = useTranslate();

    const [showUserSearchRemove, setShowUserSearchRemove] = useState(false);
    //const [userProjects, setUserProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [alert, setAlert] = useState({ visible: false });

    const [loading, setLoading] = useContext(loadingContext);

    const userSearchRemoveRef = useRef(null);

    const handleUserSelectRemove = async (user) => {
        setUsersToRemoveAccess([user]);
        setProjectsToRemoveAccess([]);
        setShowUserSearchRemove(false);

        await fetchUserProjects(user);
    };

    const handleAddAllProjects = () => {
        setProjectsToRemoveAccess((prev) => {
            const existingIds = new Set(prev.map((p) => p.id));
            const newProjects = userProjects.filter((p) => !existingIds.has(p.id));
            return [...prev, ...newProjects];
        });
    };

    const fetchUserProjects = async (user) => {
        if (!user) return;

        const authData = checkLocalStorage();
        if (!authData) {
            setLoading(false);
            return;
        }

        let token = authData.token;
        let id = authData.id;

        setLoadingProjects(true);

        try {
            const endpoint =
                user.source === "studio" || selectedRadio === "Studio"
                    ? `/studio/project/access/user/${user.id}`
                    : `/studio/project/access/client/${user.id}`;

            const response = await axios.get(urlValue + endpoint, {
                withCredentials: true,
                headers: {
                    user: id,
                    "access-token": token,
                },
            });

            setUserProjects(response.data.projects || []);
        } catch (error) {
            console.error("Error loading user projects:", error);
            openAlert("#alert-ac", () => {
                setAlert({
                    title: t("errors.loadingProjects"),
                    visible: true,
                    error: true,
                });
            });
        }

        setLoadingProjects(false);
    };

    const addProjectToRemoveList = (project) => {
        setProjectsToRemoveAccess((prev) => {
            if (prev.some((p) => p.id === project.id)) return prev;
            return [...prev, project];
        });
    };

    const removeProjectFromRemoveList = (id) => {
        setProjectsToRemoveAccess((prev) => prev.filter((p) => p.id !== id));
    };

    const handleCancel = () => {
        onClose();
        setUsersToRemoveAccess([]);
        setProjectsToRemoveAccess([]);
        setUserProjects([]);
    };

    if (!isOpen) return null;

    const selectedUser = usersToRemoveAccess[0] || null;

    return (
        <ModalVw id="remove-access-md" visible={isOpen} className="z-[500] w-[100%]" style={{ minWidth: 400 }}>
            <ModalContent clases="max-w-[1200px] bg-white" styles={{ width: "90%" }}>
                <ModalHeader
                    style={{ padding: 10 }}
                    title={<div style={{ padding: 10 }}>{t("projectAccess.removeUserAccess")}</div>}
                    onClose={handleCancel}
                />

                <ModalBody clases="p-4">
                    <div className="remove-access-container">
                        <div className="mb-4" style={{
                            backgroundColor: "#fbfdffff",
                            borderRadius: 15,
                            padding: "20px",
                            border: "1px solid #b1caddff",
                            margin: '0 10px 0 10px',
                        }}>
                            <div className="d-flex flex-row align-items-center justify-content-between mb-3">
                                <div>
                                    <h3 style={{ color: "#545454ff", fontSize: 16, margin: 0 }}>
                                        {t("projectAccess.selectUser")}
                                    </h3>
                                    <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
                                        {t("projectAccess.selectUserDescription")}
                                    </p>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    {/* Radios Studio / Client */}
                                    <div className="d-flex flex-row mr-3" style={{  }}>
                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                            <input
                                                type="radio"
                                                name="removeUserType"
                                                checked={selectedRadio === "Studio"}
                                                onChange={() => setSelectedRadio("Studio")}
                                            />
                                            <span style={{ fontSize: 14, whiteSpace: 'nowrap', marginLeft: 5 }}>{t("projectAccess.tpUserStudio")}</span>
                                        </label>

                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center", marginLeft: 20 }}>
                                            <input
                                                type="radio"
                                                name="removeUserType"
                                                checked={selectedRadio === "TP"}
                                                onChange={() => setSelectedRadio("TP")}
                                            />
                                            <span style={{ fontSize: 14, whiteSpace: 'nowrap', marginLeft: 5 }}>{t("projectAccess.tpUserClient")}</span>
                                        </label>
                                    </div>

                                    <button
                                        onClick={() => setShowUserSearchRemove((prev) => !prev)}
                                        className="buttonE buttonH"
                                        style={{ display: "flex", alignItems: "center", marginLeft: 15 }}
                                    >
                                        <img src={SearchIcon} style={{ width: 16, height: 16, filter: "brightness(2) invert(1)" }} alt="search" />
                                        <span style={{ marginLeft: 5 }}>{t("common.search")}</span>
                                    </button>
                                </div>

                                
                            </div>

                            {/* Buscador de usuarios */}
                            <div ref={userSearchRemoveRef} className="mb-3">
                                <SearchUser
                                    onUserSelect={handleUserSelectRemove}
                                    searchResultsContainer={userSearchRemoveRef.current}
                                    showSearch={showUserSearchRemove}
                                    setShowSearch={setShowUserSearchRemove}
                                    filterSource={selectedRadio === "Studio" ? "studio" : "clients"}
                                />
                            </div>

                            {/* Tabla del usuario seleccionado */}
                            {selectedUser && (
                                <div className="p-2" style={{ background: "#eef6ff", borderRadius: 8 }}>
                                    <strong>{t("projectAccess.selectedUser")}</strong> {selectedUser.ccms_name} ({selectedUser.source})
                                </div>
                            )}
                        </div>

                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                            
                            {selectedUser && (
                                <div className="mb-4" style={{
                                    backgroundColor: "#fbfdffff",
                                    borderRadius: 15,
                                    padding: "20px",
                                    border: "1px solid #bae5ffff",
                                    maxWidth: 600, margin: 10, width: '100%'
                                }}>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                        <h3 style={{ color: "#545454ff", fontSize: 16, marginBottom: 15 }}>
                                            {t('menu.projectsWithAccess')}
                                        </h3>

                                        {userProjects.length > 0 && (
                                            <button
                                                onClick={handleAddAllProjects}
                                                className="buttonE buttonH mb-2"
                                                style={{ padding: "6px 10px", fontSize: 12, whiteSpace: "nowrap" }}
                                            >
                                                ➕ {t('projectAccess.addAllProjects') || "Add all projects"}
                                            </button>
                                        )}
                                    </div>
                                    

                                    <div>
                                        <DataTable
                                            maxHeight={200}
                                            columns={[
                                                { header: t('projectAccess.projectColumn'), field: "name", width: "60%" },
                                                { header: t('projectAccess.typeColumn'), width: "20%", render: (v, r) => r.type },
                                                {
                                                    header: t('common.action'),
                                                    width: "20%",
                                                    align: "center",
                                                    render: (v, row) => (
                                                        <button className="buttonE buttonH" onClick={() => addProjectToRemoveList(row)}>
                                                            {t('common.add')}
                                                        </button>
                                                    ),
                                                },
                                            ]}
                                            data={userProjects}
                                            emptyMessage={t('projectAccess.noProjects')}
                                        />
                                    </div>
                                    
                                </div>
                            )}

                            {/* ====================================================
                            LISTA DE PROYECTOS A ELIMINAR ===== */}
                            {projectsToRemoveAccess.length > 0 && (
                                <div className="p-3" style={{
                                    backgroundColor: "#FED7D7",
                                    borderRadius: "10px", margin: 10,
                                    border: "1px solid #fcae81ff", display: 'flex', flexDirection: 'column', flexGrow: '2'
                                }}>
                                    <h4 style={{ marginBottom: 10, color: "#c56930ff" }}>
                                        {t('projectAccess.selectedProjectsRemove')}
                                    </h4>
                                    <div style={{overflowY: 'auto', maxHeight: 200}}>
                                        <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                                            {projectsToRemoveAccess.map((p) => (
                                                <li key={p.id} style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "6px 0",
                                                    borderBottom: "1px solid #f2b5b5"
                                                }}>
                                                    <span style={{fontSize: 13}}>
                                                        {p.name} ({p.type})
                                                    </span>
                                                    <button
                                                        className="buttonE buttonH"
                                                        onClick={() => removeProjectFromRemoveList(p.id)}
                                                    >
                                                        {t('common.ignore')}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    
                                </div>
                            )}
                        </div>

                        <div className="d-flex flex-row" style={{ gap: "12px", padding: 10, justifyContent: "flex-end" }}>
                            <button onClick={handleCancel} className="buttonE buttonH">
                                {t("common.cancel")}
                            </button>

                            <button
                                onClick={onConfirmRemoveAccess}
                                disabled={
                                    usersToRemoveAccess.length === 0 ||
                                    projectsToRemoveAccess.length === 0
                                }
                                className="buttonF buttonH"
                            >
                                {t("projectAccess.removeAccess")}
                            </button>
                        </div>

                    </div>
                </ModalBody>
            </ModalContent>
        </ModalVw>
    );
};

export default UserRemoveMultipleAccess;
